export class BaseModel {
    // Log
    _createdUserId: string;
    _createdDate: Date;

    _updatedUserId: string;
    _updatedDate: Date;
}
